import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import SongCard from "./components/SongCard";
import {
  Fade,
  Grid,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  useScrollTrigger,
} from "@material-ui/core";
import { Search as SearchIcon, Close as CloseIcon } from "@material-ui/icons";
import filters from "utils/search";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  // A real page title (this is the app's landing page) - scrolls away
  // with the rest of the content, unlike the search row below it.
  heading: {
    fontWeight: 700,
    paddingBottom: theme.spacing(1),
  },
  // Mirrors Catalog's mobile search header: stays put while the cards
  // below scroll past it, and slides up to top: 0 (see hideTopBar
  // below) once the shared Navigationbar hides itself on scroll down,
  // rather than leaving a gap where that bar used to be.
  stickySearch: {
    position: "sticky",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create("top"),
  },
  searchField: {
    flexGrow: 1,
  },
}));

export default ({ songs, handleOpenActionDialog }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = !useMediaQuery(theme.breakpoints.up("md"));
  // Same trigger (default threshold/hysteresis) Navigationbar's own
  // HideOnScroll uses, so this reads its hidden/shown state without
  // any actual coupling between the two components.
  const hideTopBar = useScrollTrigger();
  const [query, setQuery] = React.useState("");
  // Mobile only - collapsed by default so the header explains the page's
  // purpose instead of presenting as a search box first; desktop has
  // room to just show the field outright.
  const [mobileSearchOpen, setMobileSearchOpen] = React.useState(false);

  const closeMobileSearch = () => {
    setMobileSearchOpen(false);
    setQuery("");
  };

  let filteredSongs = songs;
  if (query) {
    const queryFilter = filters.queryFilter(query, (song) =>
      [song.title, song.artist].join(" ")
    );
    filteredSongs = queryFilter(songs);
  }

  const songCards = filteredSongs.map((song, index) => (
    <SongCard
      song={song}
      handleOpenActionDialog={handleOpenActionDialog}
      key={index}
    />
  ));

  return (
    <Fade in={true} timeout={1000}>
      <div className={classes.root}>
        <Grid container spacing={3}>
          {!mobile && (
            <Grid item xs={12}>
              <Typography variant="h5" component="h1" className={classes.heading}>
                Propose or vote for proposed songs
              </Typography>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            className={classes.stickySearch}
            style={{ top: hideTopBar ? 0 : 56 }}
          >
            {mobile && !mobileSearchOpen ? (
              <>
                <Typography className={classes.searchField}>
                  Propose or vote for proposed songs
                </Typography>
                <IconButton
                  title="Search"
                  onClick={() => setMobileSearchOpen(true)}
                >
                  <SearchIcon />
                </IconButton>
              </>
            ) : (
              <>
                <TextField
                  fullWidth
                  autoFocus={mobile}
                  className={classes.searchField}
                  value={query}
                  label="Search"
                  color="secondary"
                  onChange={(e) => setQuery(e.target.value)}
                />
                {mobile && (
                  <IconButton title="Close search" onClick={closeMobileSearch}>
                    <CloseIcon />
                  </IconButton>
                )}
              </>
            )}
          </Grid>
          {songCards}
        </Grid>
      </div>
    </Fade>
  );
};
